export const getTopBetServiceTitle = (currentPrice: number, topPrice: number): string =>
  currentPrice > topPrice ? 'Выше Топа' : 'Топ';
